import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Spinner
} from "reactstrap";
import WelcomeComp from "./WelcomeComp";
import Breadcrumbs from "components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import moment from "moment";

const API_NEWS = "https://deneme.stechomeyazilim.info/api/v1/news";
const API_CATEGORIES = "https://deneme.stechomeyazilim.info/api/v1/categories";
const API_NOTIFICATIONS = "https://mansethaberapi.stechomeyazilim.com/Notification?$format=json&$top=1000";

const Dashboard = props => {
  document.title = "Anasayfa | Manşet Haber Admin Paneli";

  const [stats, setStats] = useState({
    totalNews: 0,
    totalViews: 0,
    totalComments: 0,
    totalNotifications: 0,
    topNews: [],
    latestNews: [],
    categoryStats: [],
    loading: true,
  });

  const loadStats = async () => {
    try {
      const [newsRes, catRes, notifRes] = await Promise.all([
        fetch(`${API_NEWS}?page=1&per_page=100`),
        fetch(API_CATEGORIES),
        fetch(API_NOTIFICATIONS).catch(() => null),
      ]);

      const newsJson = await newsRes.json();
      const catJson = await catRes.json();

      const newsList = newsJson.success && Array.isArray(newsJson.data) ? newsJson.data : [];
      const catList = catJson.success && Array.isArray(catJson.data) ? catJson.data : [];

      const totalNews = catList.reduce((sum, c) => sum + (c.news_count || 0), 0);
      const totalViews = newsList.reduce((sum, n) => sum + (n.views || 0), 0);
      const totalComments = newsList.reduce((sum, n) => sum + (n.comment_count || 0), 0);

      let totalNotifications = 0;
      if (notifRes) {
        const notifText = await notifRes.text();
        if (notifText) {
          try {
            const notifJson = JSON.parse(notifText);
            totalNotifications = (notifJson.value || notifJson || []).length;
          } catch {}
        }
      }

      const sortedByViews = [...newsList].sort((a, b) => (b.views || 0) - (a.views || 0)).slice(0, 5);
      const sortedByDate = [...newsList].sort((a, b) => new Date(b.publish_date) - new Date(a.publish_date)).slice(0, 5);

      setStats({
        totalNews,
        totalViews,
        totalComments,
        totalNotifications,
        topNews: sortedByViews,
        latestNews: sortedByDate,
        categoryStats: catList.slice(0, 6),
        loading: false,
      });
    } catch (error) {
      console.error("Dashboard verileri alınamadı:", error);
      setStats((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  const statCards = [
    { title: "Toplam Haber", value: stats.totalNews, icon: "bx-news", color: "bg-primary" },
    { title: "Toplam Okunma", value: stats.totalViews.toLocaleString("tr-TR"), icon: "bx-show", color: "bg-success" },
    { title: "Toplam Yorum", value: stats.totalComments.toLocaleString("tr-TR"), icon: "bx-comment-dots", color: "bg-info" },
    { title: "Bildirim Sayısı", value: stats.totalNotifications, icon: "bx-bell", color: "bg-warning" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Yönetim")}
            breadcrumbItem={props.t("Anasayfa")}
          />

          <Row>
            <Col xl="4">
              <WelcomeComp />
            </Col>
            <Col xl="8">
              <Row>
                {statCards.map((card, key) => (
                  <Col md="3" key={key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium mb-1">{card.title}</p>
                            {stats.loading ? (
                              <Spinner size="sm" color="primary" />
                            ) : (
                              <h4 className="mb-0">{card.value}</h4>
                            )}
                          </div>
                          <div className={`avatar-sm rounded-circle ${card.color} align-self-center mini-stat-icon`}>
                            <span className={`avatar-title rounded-circle ${card.color}`}>
                              <i className={`bx ${card.icon} font-size-24`} />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xl="6">
              <Card>
                <CardBody>
                  <h5 className="card-title mb-4">
                    <i className="bx bx-trending-up me-2 text-success" />
                    En Çok Okunan Haberler
                  </h5>
                  {stats.loading ? (
                    <div className="text-center"><Spinner color="primary" /></div>
                  ) : stats.topNews.length === 0 ? (
                    <p className="text-muted">Veri bulunamadı.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Haber</th>
                            <th>Kategori</th>
                            <th className="text-end">Okunma</th>
                          </tr>
                        </thead>
                        <tbody>
                          {stats.topNews.map((item) => (
                            <tr key={item.id}>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  {item.featured_image && (
                                    <img
                                      src={item.featured_image}
                                      alt=""
                                      style={{ width: 40, height: 30, objectFit: "cover", borderRadius: 4 }}
                                    />
                                  )}
                                  <span className="text-truncate" style={{ maxWidth: 280 }}>
                                    {item.title}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <Badge color="info" className="font-size-11">
                                  {item.category?.name}
                                </Badge>
                              </td>
                              <td className="text-end">
                                <Badge color="success" className="font-size-11">
                                  {item.views}
                                </Badge>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>

            <Col xl="6">
              <Card>
                <CardBody>
                  <h5 className="card-title mb-4">
                    <i className="bx bx-time me-2 text-primary" />
                    Son Eklenen Haberler
                  </h5>
                  {stats.loading ? (
                    <div className="text-center"><Spinner color="primary" /></div>
                  ) : stats.latestNews.length === 0 ? (
                    <p className="text-muted">Veri bulunamadı.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Haber</th>
                            <th>Tarih</th>
                            <th className="text-end">Yorum</th>
                          </tr>
                        </thead>
                        <tbody>
                          {stats.latestNews.map((item) => (
                            <tr key={item.id}>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  {item.featured_image && (
                                    <img
                                      src={item.featured_image}
                                      alt=""
                                      style={{ width: 40, height: 30, objectFit: "cover", borderRadius: 4 }}
                                    />
                                  )}
                                  <span className="text-truncate" style={{ maxWidth: 280 }}>
                                    {item.title}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <span className="text-muted font-size-12">
                                  {moment(item.publish_date).format("DD.MM.YYYY HH:mm")}
                                </span>
                              </td>
                              <td className="text-end">
                                <Badge color="primary" className="font-size-11">
                                  {item.comment_count || 0}
                                </Badge>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <h5 className="card-title mb-4">
                    <i className="bx bx-pie-chart-alt me-2 text-danger" />
                    Kategorilere Göre Haber Dağılımı
                  </h5>
                  {stats.loading ? (
                    <div className="text-center"><Spinner color="primary" /></div>
                  ) : (
                    <Row>
                      {stats.categoryStats.map((cat) => (
                        <Col md="2" sm="4" xs="6" key={cat.id} className="mb-3">
                          <div className="text-center p-3 border rounded">
                            <h5 className="mb-1">{cat.news_count || 0}</h5>
                            <p className="text-muted mb-0 font-size-12">{cat.name}</p>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
